// Spanish translations for error codes
// Organized by domain, matching @idc-forms/errors structure

export const ERROR_MESSAGES: Record<string, string> = {
  // ── System ──
  INTERNAL_ERROR: 'Error interno del servidor. Por favor, intente nuevamente más tarde.',
  SERVICE_UNAVAILABLE:
    'El servicio no está disponible temporalmente. Intenta nuevamente en unos momentos.',
  VALIDATION_ERROR: 'Error de validación en los datos enviados',
  DUPLICATE_KEY: 'Ya existe un registro con estos datos',
  INVALID_ID: 'El identificador proporcionado no es válido',
  INVALID_JSON: 'La solicitud llegó con un formato que no se puede leer. Intenta nuevamente',
  MONGO_VALIDATION_ERROR: 'Error de validación en la base de datos',
  ERROR_NOT_ALLOWED: 'No tienes los permisos necesarios para realizar esta acción',
  NOT_FOUND: 'No se encontró el recurso solicitado',
  ERROR_REQUEST: 'Ocurrió un error al realizar la solicitud, intente nuevamente más tarde',
  ERROR_NOT_DELETE_DEFAULT:
    'No se puede eliminar un registro por defecto, asegurese de asignar a otro registro como por defecto',

  // ── Auth ──
  USER_OR_PASSWORD_INVALID: 'Usuario o contraseña incorrectos',
  USER_OR_EMAIL_INVALID: 'Usuario o correo electrónico incorrectos',
  USER_ALREADY_EXISTS: 'El usuario ya existe en el sistema',
  INVALID_REFRESH_TOKEN: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
  ACCESS_DENIED: 'Error de acceso',
  USER_INACTIVE: 'Usuario inactivo',
  PASSWORD_NOT_MATCH: 'Las contraseñas no coinciden',
  PASSWORD_REUSE_NOT_ALLOWED: 'La nueva contraseña debe ser diferente de la actual.',
  PASSWORD_CHANGE_CONFLICT:
    'La contraseña cambió desde otra sesión. Inicia sesión nuevamente antes de reintentar.',
  PASSWORD_RECOVERY_INVALID:
    'El enlace de recuperación expiró, ya fue utilizado o dejó de ser válido.',
  TWO_FACTOR_AUTHENTICATION_CODE_INVALID: 'Código de autenticación inválido',
  PASSWORD_NOT_VALID: 'La contraseña es incorrecta.',
  ACCESS_TOKEN_INVALID: 'Tu sesión segura ya no es válida. Confirma tu identidad nuevamente.',
  MFA_REQUIRED: 'Ingresa el código de tu aplicación de autenticación para continuar.',
  MFA_ENROLLMENT_REQUIRED: 'Activa la autenticación de dos factores para continuar.',
  MFA_CODE_INVALID: 'El código de autenticación no es válido.',
  MFA_ALREADY_ENABLED: 'La autenticación de dos factores ya está activa en tu cuenta.',
  MFA_NOT_ENABLED: 'La autenticación de dos factores no está activa en tu cuenta.',
  MFA_DEACTIVATION_NOT_ALLOWED:
    'Tu organización requiere autenticación de dos factores para esta cuenta.',
  MFA_STEP_UP_REQUIRED: 'Confirma nuevamente tu identidad para realizar esta acción.',
  MFA_POLICY_IMMUTABLE:
    'La autenticación de dos factores es obligatoria para las cuentas administradoras.',
  STAFF_SESSION_NOT_FOUND: 'La sesión ya no existe o dejó de estar activa.',
  USERNAME_ALREADY_TAKEN: 'Ese nombre de usuario ya está en uso. Elige otro.',
  EMAIL_ALREADY_TAKEN: 'Ese correo electrónico ya está en uso por otra cuenta.',

  // ── Clients ──
  ERROR_CLIENT_EXIST:
    'El cliente ya existe en el sistema con el dato de identificación proporcionado. Sugerimos realizar una búsqueda en el sistema para encontrar el cliente existente o verificar la información ingresada.',
  ERROR_STATE_INACTIVATE_NOT_FOUND: 'No se encontró el estado de inactivación',
  // El contrato v2 responde en inglés (es contrato para móvil y terceros): la
  // traducción de estos dos vive acá, que es donde se decide qué lee el usuario.
  CLIENT_HAS_NEGOTIATIONS:
    'El cliente pertenece a una o más negociaciones. Quítalo de todas sus negociaciones antes de eliminarlo.',
  NOT_AVAILABLE_IN_PRODUCTION: 'Esta operación no está disponible en producción.',
  ERROR_CLIENT_NOT_FOUND: 'No se encontró el cliente seleccionado',
  ERROR_NEXT_STATE_NOT_FOUND_ON_WORKFLOW:
    'No se encontró el siguiente estado en el flujo de trabajo',
  ERROR_CLIENT_NOT_HAVE_WORKFLOW: 'El cliente no tiene un flujo de trabajo asignado',
  ERROR_CLIENT_HAVE_WORKFLOW: 'El cliente ya tiene un flujo de trabajo asignado',
  ERROR_CLIENT_IS_NOT_STATE_PROCESS: 'El cliente no se encuentra en un estado de proceso',
  ERROR_CLIENT_STATE_IS_INIT_OR_NOT_WORKFLOW_ASSIGN:
    'El estado del cliente es inicial o no tiene un flujo de trabajo asignado',
  ERROR_CLIENT_IS_NOT_STATE_END_OR_INACTIVE:
    'El cliente no se encuentra en estado final o inactivo',
  ERROR_CLIENT_IS_STATE_END: 'El cliente se encuentra en estado finalizado',
  ERROR_CLIENT_IS_STATE_INACTIVE: 'El cliente se encuentra inactivo',
  ERROR_CLIENT_IS_NOT_STATE_INACTIVE: 'El cliente no se encuentra inactivo',
  ERROR_STATE_CAN_NOT_UNDEFINED: 'El estado no puede ser indefinido',
  ERROR_STATE_IS_MAJOR: 'El estado es mayor al estado actual',
  ERROR_REMOVE_ADVISOR: 'No se puede remover al asesor',
  ERRRO_UPDATE_ADVISOR: 'No se puede actualizar al asesor',
  ERROR_REMOVE_GROUP: 'No se puede remover al grupo',
  ERRRO_UPDATE_GROUP: 'No se puede actualizar al grupo',
  ERROR_ADVISOR_NOT_SELECTED: 'Debe seleccionar un asesor',
  ERROR_GROUP_NOT_SELECTED: 'Debe seleccionar un grupo',
  ERROR_IS_NOT_ADVISOR: 'El usuario no es un asesor',

  // ── Negotiations ──
  ERROR_NEGOTIATION_ACCESS_DENIED:
    'No tienes los permisos necesarios para acceder a la negociación seleccionada',
  ERROR_NEGOTIATION_NOT_FOUND: 'No se puede encontrar la negociación seleccionada',
  ERROR_CREATE_NEGOTIATION_BY_PROPERTY_WITH_NEGOTIATION_ACTIVE:
    'No se puede crear una nueva negociación para un inmueble con una negociación activa',
  ERROR_UPDATE_NEGOTIATION_WITH_NEGOTIATION_ACTIVE:
    'No se puede actualizar la negociación por que el inmueble tiene una negociación activa',
  ERROR_NEGOTIATION_IS_STATE_INACTIVE:
    'No se puede realizar esta acción porque la negociación está inactiva',
  ERROR_NEGOTIATION_IS_NOT_STATE_INACTIVE:
    'No se puede realizar esta acción porque la negociación está activa',
  ERROR_STATE_PROCESS_ASSIGN_BUT_WORKFLOW_NOT:
    'No se puede realizar esta acción porque el flujo de trabajo no se encuentra asignado',
  ERROR_NEXT_STATE_NOT_FOUND:
    'No se puede realizar esta acción porque el siguiente estado no se encuentra',
  ERROR_NEGOTIATION_NOT_HAVE_WORKFLOW:
    'No se puede realizar esta acción porque la negociación no tiene un flujo de trabajo asignado',
  ERROR_NEGOTIATION_IS_NOT_STATE_PROCESS:
    'No se puede realizar esta acción porque la negociación no se encuentra en un estado de proceso',
  ERROR_NEGOTIATION_IS_STATE_RESCIND:
    'No se puede realizar esta acción porque la negociación se encuentra en un estado de rescisión',
  ERROR_NEGOTIATION_IS_STATE_END:
    'No se puede realizar esta acción porque la negociación se encuentra en un estado de finalizado',
  ERROR_NEGOTIATION_DEFAULT_OWNER_NOT_FOUND:
    'No se puede realizar esta acción porque el propietario por defecto no se encuentra',
  ERROR_NEGOTIATION_STATE_IS_INIT_OR_NOT_WORKFLOW_ASSIGN:
    'No se puede realizar esta acción porque el estado no es inicial o no tiene un flujo de trabajo asignado',
  ERROR_NEGOTIATION_PAYMENT_AGREEMENT_TOTAL_AMOUNT_NOT_FOUND:
    'No se puede realizar esta acción porque el total de la cuota no se encuentra',
  ERROR_NEGOTIATION_MISSING_REQUIRED_ATTACHMENTS:
    'No se puede avanzar al siguiente estado porque faltan adjuntos obligatorios del estado actual',
  ERROR_NEGOTIATION_PROPERTY_RESERVED:
    'No se puede crear una negociación porque el inmueble está apartado. Debe liberarse primero.',
  ERROR_NEGOTIATION_RESCIND_APPROVED_FORBIDDEN:
    'No tienes permisos para rescindir una negociación aprobada',
  // ── Negotiations · ALTA Y EDICIÓN POR API v2 ──
  //
  // Los cuatro que faltaban del formulario, medidos el 2026-08-05 junto con los de transiciones.
  // Son los que alguien encuentra CARGANDO un expediente, no moviéndolo.
  USER_IS_NOT_ADVISOR: 'El usuario seleccionado no es un asesor',
  // El mensaje del servidor nombra el permiso interno que falta
  // (`FieldAmountsWithoutTaxNegotiation`); la traducción existe también para NO mostrarlo.
  FORBIDDEN_FIELD: 'No tienes permisos para editar alguno de los campos enviados',
  PROPERTY_RESERVED:
    'No se puede crear la negociación porque el inmueble está apartado por otra persona. Debe liberarse primero.',
  /*
   * ⚠️ `INVALID_REFERENCE` se traduce SABIENDO que se pierde algo, y conviene dejarlo dicho.
   *
   * El mensaje del servidor lleva contexto dinámico —«Unknown reference in "advisor": usr_x»— y la
   * prioridad 1 de `getErrorMessage` es la traducción, así que ponerla acá TAPA ese detalle. Se
   * hace igual por dos razones: está en inglés, y ese detalle es para quien depura, no para quien
   * carga el formulario — un `usr_` no le dice nada a la persona y no le indica qué corregir.
   *
   * Lo que sí le sirve es saber que algo que eligió ya no existe y que recargando se arregla, que
   * es la causa real: un selector con datos viejos apuntando a un registro borrado. El detalle
   * técnico sigue viajando a Sentry por el `errorCode` y el `requestId`.
   */
  INVALID_REFERENCE:
    'Alguno de los datos seleccionados ya no existe. Actualiza la página e intenta de nuevo.',

  // ── Negotiations · TRANSICIONES POR API v2 ──
  //
  // Los códigos de v2 NO llevan prefijo `ERROR_` y renombran condiciones que arriba ya estaban
  // traducidas: `NEGOTIATION_ALREADY_INACTIVE` es el `ERROR_NEGOTIATION_IS_STATE_INACTIVE` de v1,
  // `NEGOTIATION_IS_NOT_IN_PROCESS` el `..._IS_NOT_STATE_PROCESS`, y así. Al migrar las cinco
  // transiciones se renombraron los códigos y las traducciones se quedaron con los nombres viejos:
  // medido el 2026-08-05, **catorce de catorce** códigos de transición no tenían entrada acá.
  //
  // Sin traducción, `getErrorMessage` cae a la prioridad 2 —el texto del servidor— que en v2 es el
  // `detail` de Problem Details y está **en inglés**. O sea que cada transición rechazada le
  // contestaba «Only a negotiation in a process state can advance» a un producto que está en
  // español.
  //
  // El texto se adapta del que ya existía para el gemelo de v1 en vez de inventarlo: la condición
  // de negocio es la misma y el copy ya estaba acordado.
  NEGOTIATION_ALREADY_INACTIVE: 'La negociación ya está inactiva',
  NEGOTIATION_IS_NOT_INACTIVE:
    'No se puede realizar esta acción porque la negociación no está inactiva',
  NEGOTIATION_ALREADY_RESCINDED: 'La negociación ya está rescindida',
  NEGOTIATION_IS_NOT_IN_PROCESS:
    'No se puede realizar esta acción porque la negociación no se encuentra en un estado de proceso',
  NEGOTIATION_HAS_NO_PREVIOUS_STEP:
    'No se puede devolver la negociación porque ya está en el primer paso de su flujo',
  NEGOTIATION_HAS_NO_PREVIOUS_STATE:
    'No se puede reactivar la negociación porque no hay un estado anterior al que volver',
  // El estado actual dejó de ser un paso del flujo — pasa al borrar un estado, que lo saca de
  // todos los flujos que lo referencian.
  NEGOTIATION_IS_OFF_WORKFLOW:
    'No se puede avanzar porque el estado actual ya no forma parte del flujo de trabajo de la negociación',
  NEGOTIATION_MISSING_REQUIRED_ATTACHMENTS:
    'No se puede avanzar al siguiente estado porque faltan adjuntos obligatorios del estado actual',
  // Crear y editar sin propietarios se permite —el expediente se arma de a poco—; lo que no se
  // puede es moverlo del primer estado sin saber de quién es. El texto dice QUÉ hacer, no sólo
  // qué falta: es la diferencia entre un rechazo y una instrucción.
  NEGOTIATION_HAS_NO_OWNERS:
    'Agrega al menos un propietario antes de enviar la negociación al siguiente estado',
  // La negociación que creaste sigue en tu tabla aunque no puedas abrirla: el texto tiene que
  // explicar esa rareza, porque la persona la está VIENDO en pantalla. Sin esto caía en «No se
  // pudo cargar» con un botón Reintentar que acá no puede funcionar nunca — no es un fallo
  // transitorio, es una decisión de permisos.
  NEGOTIATION_READ_NOT_ALLOWED:
    'Ves esta negociación porque tú la creaste, pero no tienes permisos para abrirla en el estado en el que está',
  NEGOTIATION_ACTIVATION_FORBIDDEN: 'No tienes permisos para reactivar negociaciones',
  NEGOTIATION_RESCIND_APPROVED_FORBIDDEN:
    'No tienes permisos para rescindir una negociación aprobada',
  // Se pide sobre el estado DESTINO: «puedo traer negociaciones hacia acá», no «puedo sacarlas».
  STATE_TRANSITION_FORBIDDEN: 'No tienes permisos para mover la negociación a ese estado',
  PROPERTY_HAS_ACTIVE_NEGOTIATION:
    'El inmueble ya tiene una negociación activa, así que no se puede continuar con esta',
  // El inmueble está fuera del catálogo — típicamente porque ya se vendió. El selector no lo
  // ofrece, así que llegar acá desde la pantalla no debería pasar; el texto dice qué hacer para
  // quien llegue por otro camino.
  NEGOTIATION_IS_CLOSED: 'La venta ya está firmada y no se puede editar',
  PROPERTY_NOT_SELLABLE:
    'El inmueble está fuera del catálogo y no puede entrar en una negociación. Si se va a vender de nuevo, primero hay que reactivarlo',
  // Alguien movió el expediente entre que se abrió la pantalla y se confirmó la acción. El
  // servidor NO escribe nada en ese caso, así que el texto tiene que decir dos cosas: que no se
  // hizo, y qué hacer — recargar, porque lo que se ve en pantalla ya es viejo.
  NEGOTIATION_MOVED:
    'Otra persona movió la negociación mientras hacías esto, así que no se aplicó. Recarga la página para ver en qué estado quedó.',
  WORKFLOW_NOT_FOUND:
    'No se puede realizar esta acción porque la negociación no tiene un flujo de trabajo asignado',
  STATE_NOT_FOUND: 'No se puede realizar esta acción porque el estado no se encuentra',

  ERROR_CURRENCY_PRINT_NOT_FOUND:
    'El tipo de moneda es obligatorio para la impresión del documento',

  // ── SAP ──
  ERROR_SAP_LOGIN: 'Error al iniciar sesión en SAP',
  ERROR_SAP_WRONG_CREDENTIALS: 'Credenciales incorrectas para iniciar sesión en SAP',
  ERROR_SAP_GET_OP_DEPENDENCIES: 'Error al obtener las dependencias de SAP',
  ERROR_SAP_GET_OP_LEVEL: 'Error al obtener los niveles de SAP',
  ERROR_SAP_GET_OP_LEVEL_NOT_VALID: 'Error al obtener los niveles de SAP',
  ERROR_SAP_GET_ORDER_PRODUCTION: 'Error al obtener la producción de SAP',
  ERROR_SAP_UPDATE_ORDER_PRODUCTION: 'Error al actualizar la producción de SAP',
  ERROR_SAP_CREATE_ORDER_PRODUCTION: 'Error al crear la producción de SAP',
  ERROR_SAP_GET_ORDER_PRODUCTION_NOT_FOUND: 'No se encontró la producción en SAP',
  ERROR_SAP_ORDER_PRODUCTION_WITHOUT_DEPENDENCIES:
    'No se puede realizar esta acción porque la producción no tiene dependencias',
  ERROR_SAP_CREATE_BUSINESS_PARTNER: 'Error al crear el cliente en SAP',
  ERROR_SAP_OPERATION: 'Error al realizar la operación en SAP',
  ERROR_SAP_INVALID_BUSINESS_PARTNER_TYPE: 'El tipo de cliente no es valido para crear en SAP',
  ERROR_SAP_BUSINESS_PARTNER_NOT_FOUND: 'No se encontró el cliente en SAP',
  ERROR_SAP_ORDER_PRODUCTION_NOT_FOUND: 'No se encontró la orden de producción en SAP',
  ERROR_SAP_CREATE_ORDER: 'Error al crear la orden en SAP',
  ERROR_SAP_ASSIGN_PAYMENT_PLAN_TO_ORDER: 'Error al asignar el plan de pago a la orden en SAP',
  ERROR_SAP_UPDATE_ORDER: 'Error al actualizar la orden en SAP',
  ERROR_SAP_ORDER_NOT_FOUND: 'No se encontró la orden en SAP',
  ERROR_SAP_UPDATE_PAYMENT_PLAN: 'Error al actualizar el plan de pago en SAP',
  ERROR_SAP_REMOVE_PAYMENT_PLAN: 'Error al eliminar el plan de pago en SAP',
  ERROR_SAP_ORDER_BUSINESS_PARTNER_NOT_CAN_BE_UPDATED:
    'No se puede actualizar el cliente de la orden porque ya tiene un cliente asignado, para poder actualizar el cliente, se debe eliminar la orden y crear una nueva',

  // ── Reservations ──
  ERROR_PROPERTY_NOT_AVAILABLE: 'El inmueble no está disponible para apartar',
  ERROR_RESERVATION_ALREADY_EXISTS: 'El inmueble ya tiene un apartado activo',
  ERROR_RESERVATION_NOT_FOUND: 'No se encontró el apartado',
  ERROR_RESERVATION_NOT_ACTIVE: 'El apartado no se encuentra activo',
  ERROR_RESERVATION_NOT_OWNER: 'No tienes permisos sobre este apartado',
  ERROR_RESERVATION_ALREADY_AUTHORIZED: 'El apartado ya fue autorizado',
  ERROR_RESERVATION_ALREADY_DECLINED: 'El apartado ya fue rechazado',
  ERROR_RESERVATION_EXPIRED: 'El apartado ha expirado',
  ERROR_RESERVATION_MAX_DAYS_EXCEEDED: 'El apartado no puede exceder 3 días',
  ERROR_RESERVATION_NOT_PENDING: 'El apartado no se encuentra pendiente',
  ERROR_PROPERTY_RESERVED: 'El inmueble ya se encuentra apartado',
  ERROR_NOT_AUTHORIZER: 'No tienes permisos para autorizar este apartado',

  // ── RENAP ──
  RENAP_ERROR: 'Error al realizar la operación en RENAP',
  WRONG_CREDENTIALS: 'Las credenciales de acceso a RENAP son incorrectas',
  TOKEN_INVALID: 'No tienes accesos al servicio de RENAP (Token invalido)',
  INVALID_CUI: 'El número de identificación es invalido',
  NO_MATCH: 'No se encontro ningún resultado',

  // ── Catalog (smaller modules) ──
  ERROR_WORKFLOW_NOT_FOUND:
    'No se puede realizar esta acción porque el flujo de trabajo no se encuentra asignado',
  // Faltaba: sin mapeo, el toast mostraba el `message` en INGLÉS que manda el
  // backend. Afecta a v1 y v2 por igual — lo destapó el E2E visual de la tajada v2.
  ERROR_WORKFLOW_EXIST: 'Ya existe un flujo de trabajo con ese nombre',
  ERROR_NOT_UPDATE_ACTION_DEFAULT:
    'No se puede cambiar la acción de un registro por defecto, asegurese de asignar a otro registro como por defecto',
  ERROR_NOT_DELETE_BLOCKED: 'No se puede eliminar un registro bloqueado',
  ERROR_CANNOT_ADD_MORE_OPTIONS_IF_CREATE_EXISTS:
    'No se pueden agregar más opciones si ya existe una opción de creación',
  ERROR_STATES_NOT_EMPTY: 'No se puede realizar esta acción porque existen estados asociados',
  ERROR_STATE_NOT_FOUND: 'No se encontró el estado seleccionado',
  ERROR_STATE_EXIST: 'Ya existe un estado con el mismo nombre',
  ERROR_IS_NOT_TYPE_PROCESS: 'El estado no es de tipo proceso',
  ERROR_EMAILS_NOTIFICATION_EMPTY: 'Debe configurar al menos un correo de notificación',
  ERROR_COMPANY_EXIST: 'Ya existe una empresa con el mismo nombre',
  ERROR_COMPANY_NOT_DELETE_DEFAULT:
    'No se puede eliminar una empresa por defecto, asegurese de asignar a otra empresa como por defecto',
  ERROR_COMPANY_NOT_DELETE_BLOCKED: 'No se puede eliminar una empresa bloqueada',
  ERROR_COMPANY_NOT_DELETE: 'No se puede eliminar esta empresa',
  ERROR_COMPANY_NOT_DEFAULT_CVN: 'La empresa no puede ser la empresa por defecto CVN',
  ERROR_COMPANY_NOT_INACTIVE: 'No se puede inactivar esta empresa',
  ERROR_COMPANY_NOT_INACTIVE_DEFAULT: 'No se puede inactivar la empresa por defecto',
  ERROR_COMPANY_NOT_FOUND: 'No se encontró la empresa seleccionada',
  ERROR_SOCIETY_EXIST: 'Ya existe una sociedad con el mismo nombre',
  ERROR_SOCIETY_NOT_FOUND: 'No se puedo encontrar la sociedad seleccionada',
  ERROR_PROJECT_EXIST: 'Ya existe un proyecto con el mismo nombre o código',
  ERROR_PROJECT_NOT_FOUND: 'No se puedo encontrar el proyecto seleccionado',
  ERROR_TYPE_PROPERTY_NOT_FOUND: 'No se puedo encontrar el subtipo seleccionado',
  ERROR_TYPE_PROPERTY_EXIST: 'Ya existe un subtipo con el mismo código y proyecto seleccionado',
  ERROR_PROPERTY_EXIST: 'Ya existe un inmueble con el mismo nombre o código',
  ERROR_PROPERTY_NOT_FOUND: 'No se puedo encontrar el inmueble seleccionado',
  ERROR_AGENCY_NOT_FOUND: 'No se encontró la agencia seleccionada',
  ERROR_AGENCY_EXIST: 'Ya existe una agencia con el mismo código en la empresa seleccionada',
  ERROR_AGENCY_NOT_DELETE_DEFAULT: 'No se puede eliminar una agencia por defecto',
  ERROR_AGENCY_NOT_DELETE_BLOCKED: 'No se puede eliminar una agencia bloqueada',
  ERROR_AGENCY_NOT_INACTIVE_DEFAULT: 'No se puede inactivar la agencia por defecto',
  ERROR_MANDATARY_NOT_DELETE_DEFAULT: 'No se puede eliminar un mandatario por defecto',
  ERROR_MANDATARY_NOT_DELETE_BLOCKED: 'No se puede eliminar un mandatario bloqueado',
  ERROR_MANDATARY_NOT_INACTIVE_DEFAULT: 'No se puede inactivar el mandatario por defecto',
  ERROR_REPRESENTATIVE_NOT_FOUND: 'No se encontró el representante legal seleccionado',
  ERROR_REPRESENTATIVE_NOT_DELETE_DEFAULT: 'No se puede eliminar un representante por defecto',
  ERROR_REPRESENTATIVE_NOT_DELETE_BLOCKED: 'No se puede eliminar un representante bloqueado',
  ERROR_REPRESENTATIVE_NOT_INACTIVE_DEFAULT: 'No se puede inactivar el representante por defecto',
  ERROR_REPRESENTATIVE_SOCIETY_ALREADY_HAS_ONE:
    'Esta sociedad ya tiene un representante legal asignado. Solo se permite un representante por sociedad.',
  ERROR_FOLDER_NOT_FOUND: 'No se encontró la carpeta seleccionada',
  ERROR_BLOCKED_FOLDER_NOT_DELETE: 'No se puede eliminar una carpeta bloqueada',
  ERROR_FOLDER_PARENT_NOT_EQUAL: 'La carpeta padre no coincide',
  ERROR_DELETE_CHILDRENS: 'No se puede eliminar porque contiene elementos',
  ERROR_FOLDER_EXISTS: 'Ya existe una carpeta con el mismo nombre',
  ERROR_USER_NOT_FOUND: 'No se encontró el usuario seleccionado',
  ERROR_USER_IS_NOT_ADVISOR: 'El usuario no es un asesor',
  ERROR_ASSIGN_ROLE: 'Error al asignar el rol',
  ERROR_CREATE_ROLE: 'Error al crear el rol',
  ERROR_ROLE_EXIST: 'Ya existe un rol con este nombre',
  ERROR_ROLE_NOT_FOUND: 'No se encontró el rol seleccionado',
  ERROR_GROUP_NOT_FOUND: 'No se encontró el grupo seleccionado',
  ERROR_UPLOAD_FILE: 'Error al subir el archivo',
  ERROR_DELETE_FILES: 'Error al eliminar los archivos',
  ERROR_FILE_NOT_FOUND: 'No se encontró el archivo',
  ERROR_DELETE_FILE: 'Error al eliminar el archivo',
  ERRRO_FILE_MAX_SIZE_EXCEEDED: 'El archivo excede el tamaño máximo permitido',
  ERROR_UPLOAD_PHOTO_CLIENT: 'Error al subir la foto del cliente',
  ERROR_COUNTRY_NOT_DELETE_DEFAULT: 'No se puede eliminar un país por defecto',
  ERROR_COUNTRY_NOT_INACTIVE_DEFAULT: 'No se puede inactivar el país por defecto',
  ERROR_COUNTRY_NOT_DELETE_OTHER_PROFESSION: 'No se puede eliminar la profesión "Otro"',
  ERROR_PROFESSION_NOT_FOUND: 'No se encontró la profesión seleccionada',
  ERROR_PROFESSION_EXIST: 'Ya existe una profesión con ese nombre',
  ERROR_PROFESSION_NOT_UPDATE_OTHER: 'No se puede editar la profesión "Otro"',

  /*
   * `INVALID_SORT` nace con esta tajada (decisión Nº 17) y su traducción viaja CON ella.
   *
   * Se agrega acá y no en la tanda de traducciones (#311) porque el guardarraíl que esa tanda
   * introduce —`v2-mechanical-codes-translated.spec.ts`— exige texto para todo `INVALID_*`. Un
   * código nuevo sin su traducción deja el guardarraíl en rojo al mergear, y el que lo introduce
   * es quien tiene que traerla: si no, la deuda la paga el que llega después sin saber por qué.
   *
   * Y el mensaje NO dice «campo inválido»: dice qué pasó y qué hacer. Un `sort` desconocido llega
   * casi siempre desde un enlace viejo o compartido, no de la pantalla —los ordenables están
   * acotados por el contrato—, así que quien lo ve no eligió mal: heredó una URL.
   */
  INVALID_SORT: 'No se puede ordenar por ese campo en este listado. Elige otra columna.',

  /*
   * ── API v2 — códigos de CONTRATO E INFRAESTRUCTURA ─────────────────────────
   *
   * Medido el 2026-08-12 (decisión Nº 22): de los 116 códigos que v2 lanza, **49 no tenían
   * traducción**, y sin ella `getErrorMessage` cae al `detail` de Problem Details, que está en
   * INGLÉS sobre un producto enteramente en español.
   *
   * Estos son los **32 mecánicos**: contrato e infraestructura, donde el texto NO depende de
   * conocer la pantalla. Los 17 restantes son copy de producto —diez de ellos de reservas, un
   * carril sin migrar— y esperan criterio de negocio: escribirlos desde acá sería inventar.
   */

  // Ids públicos que no resuelven. NO son errores de quien usa la pantalla: son datos rotos, y el
  // mensaje no puede sugerir que reintente algo que no va a cambiar por reintentar.
  AGENCY_PUBLIC_ID_MISSING: 'No se pudo identificar la agencia. Es un problema del registro.',
  COMPANY_PUBLIC_ID_MISSING: 'No se pudo identificar la empresa. Es un problema del registro.',
  PROJECT_PUBLIC_ID_MISSING: 'No se pudo identificar el proyecto. Es un problema del registro.',
  PROPERTY_PUBLIC_ID_MISSING: 'No se pudo identificar el inmueble. Es un problema del registro.',
  SOCIETY_PUBLIC_ID_MISSING: 'No se pudo identificar la sociedad. Es un problema del registro.',
  STATE_PUBLIC_ID_MISSING: 'No se pudo identificar el estado. Es un problema del registro.',
  ROLE_PUBLIC_ID_MISSING: 'No se pudo identificar el rol. Es un problema del registro.',
  USER_PUBLIC_ID_MISSING: 'No se pudo identificar al usuario. Es un problema del registro.',
  WORKFLOW_PUBLIC_ID_MISSING: 'No se pudo identificar el flujo. Es un problema del registro.',
  PROFESSION_PUBLIC_ID_MISSING: 'No se pudo identificar la profesión. Es un problema del registro.',
  REPRESENTATIVE_PUBLIC_ID_MISSING:
    'No se pudo identificar al representante legal. Es un problema del registro.',
  TYPE_PROPERTY_PUBLIC_ID_MISSING:
    'No se pudo identificar el tipo de inmueble. Es un problema del registro.',
  ATTACHMENT_REQUIREMENT_PUBLIC_ID_MISSING:
    'No se pudo identificar el requisito documental. Es un problema del registro.',
  INVENTORY_COMMENT_PUBLIC_ID_MISSING:
    'No se pudo identificar el comentario. Es un problema del registro.',

  // No encontrados.
  ADVISOR_NOT_FOUND: 'No se encontró el asesor seleccionado',
  ATTACHMENT_REQUIREMENT_NOT_FOUND: 'No se encontró el requisito documental',
  REFERENCE_NOT_FOUND: 'No se encontró el registro al que se hace referencia',
  ERROR_AUTHORIZER_NOT_FOUND: 'No se encontró al autorizador',

  // Nombres ya tomados. Dicen QUÉ cambiar, que es lo único accionable.
  COMPANY_NAME_ALREADY_TAKEN: 'Ya existe una empresa con ese nombre. Elige otro.',
  ROLE_NAME_ALREADY_TAKEN: 'Ya existe un rol con ese nombre. Elige otro.',
  STATE_NAME_ALREADY_TAKEN: 'Ya existe un estado con ese nombre. Elige otro.',
  ATTACHMENT_REQUIREMENT_DUPLICATED: 'Ese requisito documental ya está en la lista.',
  CLIENT_DUPLICATE: 'Ya existe un cliente con esos datos',

  // Contrato del listado. El usuario rara vez los provoca desde la pantalla —los filtros están
  // acotados— pero sí al abrir un enlace viejo o compartido.
  INVALID_CURSOR: 'La página que intentas abrir ya no es válida. Vuelve a la primera página.',
  INVALID_FILTER: 'Uno de los filtros no está permitido en este listado.',
  INVALID_FILTER_VALUE: 'El valor de uno de los filtros no es válido para ese campo.',
  INVALID_PAGE_SIZE: 'El tamaño de página solicitado está fuera del rango permitido.',

  // Referencias inválidas al guardar.
  INVALID_ROLE: 'El rol seleccionado no es válido',
  INVALID_STATE: 'El estado seleccionado no es válido',
  INVALID_USER: 'El usuario seleccionado no es válido',

  // Transporte. Ninguno de los dos lo puede resolver quien está mirando la pantalla, así que el
  // texto no le pide nada: le dice qué pasó y que no fue culpa suya.
  CSRF_ORIGIN_DENIED:
    'La solicitud se rechazó por seguridad: no proviene de un origen autorizado. Vuelve a abrir la aplicación desde su dirección habitual.',
  V2_WIRE_CONTRACT_VIOLATION:
    'La respuesta del servidor no tiene el formato esperado. No es algo que puedas corregir desde aquí.',

  // ── Frontend-only (no backend counterpart) ──
  GENERIC_ERROR: 'Ocurrió un error, intente nuevamente más tarde',
  ERROR_FETCH_RECORD: 'Hubo un error al obtener el registro',
  ERROR_UNKNOWN: 'Error desconocido',
  ERROR_AUTHENTICATION: 'Error de autenticación',
  ERROR_SESSION_EXPIRED: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
  ERROR_FORBIDDEN_NEGOTIATION: 'No tienes los permisos necesarios para acceder a esta negociación.',
  ERROR_FORBIDDEN_ACTION_NEGOTIATION:
    'No tienes los permisos necesarios para realizar esta acción en esta negociación.',
  LOGIN_ERROR: 'Ocurrió un error al iniciar sesión, intente nuevamente más tarde',
  UNAUTHORIZED: 'No autorizado',
  ERROR_PERMISSION: 'No tienes los permisos necesarios para realizar esta acción',

  /*
   * ── LOS CÓDIGOS DE COPY DE PRODUCTO (decisión Nº 46) ────────────────────────
   *
   * La tanda mecánica (#311) tradujo los 32 códigos cuyo texto NO dependía de conocer la pantalla.
   * Estos NO son ésos: cada uno es una regla de negocio, y escribir su texto pide saber qué está
   * mirando la persona cuando lo recibe. Por eso esperaron a que alguien decidiera.
   *
   * Van redactados con la misma regla que `INVALID_SORT`: **qué pasó y qué hacer**. Un mensaje que
   * sólo nombra el impedimento —«no se puede eliminar»— deja a la persona buscando el motivo en
   * otro lado, que es el trabajo que el mensaje venía a ahorrarle.
   *
   * ☠️ LOS QUE NO ESTÁN, Y POR QUÉ NO ES UN OLVIDO
   *
   * De los 23 códigos v2 sin traducción medidos el 2026-08-12, acá entran 12. Los otros once:
   *
   * | | | |
   * | --- | ---: | --- |
   * | **Reservas** | 9 | `RESERVATION_*`. **Su carril no está migrado.** Escribir hoy el texto del error de una pantalla que nadie diseñó es inventarlo — viajan con su carril |
   * | **App móvil** | 2 | `CLIENT_APP_ACCESS_EXPIRED` y `CLIENT_APP_DOCUMENT_UNAVAILABLE`. **Ya están traducidos**, en `apps/mobile/src/shared/domain/error-state.ts`, con título y descripción propios. Repetirlos acá sería texto muerto: ninguna pantalla de la web los recibe |
   *
   * `INVENTORY_RESERVATION_CONFLICT` sí entra aunque hable de reservas: lo lanza **inventario**, que
   * está migrado, y se ve en la ficha del inmueble. Lo que difiere el carril de reservas es su
   * pantalla, no la palabra.
   */

  /*
   * Los tres 503 de datos inconsistentes. Son la misma clase de error: la API encontró algo que su
   * propio modelo dice que no puede pasar, así que **reintentar no arregla nada** y el texto no lo
   * sugiere. Nombran el dato roto para que quien reporte pueda decir cuál.
   */
  INVENTORY_COMMENT_PARENT_MISSING:
    'Un comentario de este inmueble responde a otro que ya no existe. Es un problema del registro: avisa a soporte para que lo revisen.',
  INVENTORY_COMMENT_NESTING_CONFLICT:
    'Los comentarios de este inmueble tienen más niveles de respuesta de los permitidos. Es un problema del registro: avisa a soporte para que lo revisen.',
  INVENTORY_RESERVATION_CONFLICT:
    'Este inmueble figura con más de una reserva vigente al mismo tiempo. Es un problema del registro: avisa a soporte para que lo revisen.',

  /* Reglas de negocio: la acción es válida, el momento o el objetivo no. */
  INVENTORY_COMMENT_NESTING_NOT_ALLOWED:
    'Solo puedes responder a un comentario original, no a una respuesta. Escribe tu respuesta en el comentario que inició la conversación.',
  CLIENT_HAS_ACTIVE_FLOW:
    'No puedes editar este cliente mientras tenga un formulario del portal abierto. Cierra o cancela el formulario y vuelve a intentarlo.',
  CLIENT_ACCOUNT_EMAIL_TAKEN:
    'Ya existe una cuenta de cliente con ese correo. Usa otro correo o busca la cuenta existente.',
  CLIENT_ACCOUNT_INVITATION_THROTTLED:
    'La invitación se envió hace muy poco. Espera unos minutos antes de volver a enviarla.',
  // El 409 de las cinco operaciones que alcanzan al cliente (invitar o reenviar, abrir cuenta,
  // conceder acceso, liberar acceso, enviar un aviso) mientras la app no está publicada. La web ya
  // las deshabilita; esto es lo que se lee si web y API discrepan de flag. Nada se escribió.
  CLIENT_APP_NOT_LAUNCHED:
    'La app todavía no está publicada, así que esta acción no está disponible. Podrás usarla cuando se publique.',
  CUSTOM_RECIPIENTS_REQUIRED:
    'La notificación personalizada necesita al menos un correo de destino. Agrega uno o elige otro tipo de notificación.',
  STATE_TYPE_NOT_CONFIGURABLE:
    'Solo los estados de proceso admiten documentos requeridos. Cambia el tipo del estado o quita el requisito.',
  ERROR_PROFESSION_NOT_DELETE_OTHER:
    'No se puede eliminar la profesión "Otro": es la que recoge las profesiones escritas a mano.',

  /*
   * Las dos guardas de administración. La primera protege a la plataforma de quedarse sin nadie que
   * la administre; la segunda evita que un administrador se desbloquee solo, que es justamente lo
   * que el MFA vino a impedir. Las dos dicen quién SÍ puede hacerlo, porque el camino existe.
   */
  LAST_ADMINISTRATOR:
    'La plataforma necesita al menos un administrador activo. Asigna el rol a otra persona antes de quitar este acceso.',
  SELF_ACTION_NOT_ALLOWED:
    'No puedes restablecer tu propia verificación en dos pasos. Pídeselo a otro administrador.',

  /*
   * ☠️ ESTOS DOS LOS TRAJO EL GUARDARRAÍL, NO UNA REVISIÓN.
   *
   * Nacieron con el borrado de estados que migra expedientes (decisión Nº 24) y llegaron sin texto.
   * El caso «lo único que queda sin traducir es el carril de reservas» se puso en rojo al mergear y
   * los nombró a los dos — que es exactamente para lo que se escribió, y en su primera oportunidad.
   *
   * `STATE_HAS_PARKED_NEGOTIATIONS` es el único de toda esta tanda cuyo `detail` del servidor dice
   * MÁS que el texto de acá: trae **cuántos** expedientes hay. Se traduce igual —el resto del
   * producto está en español— pero el conteo se pierde, y por eso el mensaje empuja a mirar la
   * pantalla, donde el número está.
   */
  STATE_HAS_PARKED_NEGOTIATIONS:
    'Este estado todavía tiene expedientes dentro. Elige a qué estado se mueven antes de eliminarlo.',
  STATE_DESTINATION_IS_SOURCE:
    'El estado de destino no puede ser el que estás eliminando. Elige otro.',

  /*
   * El portal del cliente en v2 (carril D). Igual que los dos de arriba, este código lo trajo el
   * guardarraíl y no una revisión: apareció en rojo en la misma corrida en que se escribió el
   * endpoint que lo lanza.
   *
   * El texto NO ofrece reintentar. Un `pfr_` que no resuelve es un enlace viejo o un id copiado
   * mal, y las dos cosas siguen sin resolver por más veces que se pida.
   */
  PORTAL_REQUEST_NOT_FOUND:
    'No se encontró el expediente del portal. Es posible que se haya eliminado o que el enlace sea de otro entorno.',

  /*
   * ☠️ El único de esta tanda cuyo mensaje NO puede decir todo lo que la API sabe.
   *
   * El `detail` del servidor trae el estado actual y la transición pedida —«un expediente en
   * 'approved' no acepta 'approve'»— y la tabla es estática, así que acá el texto tiene que servir
   * para las siete transiciones y los doce estados a la vez.
   *
   * Por eso NO nombra ninguna acción y manda a mirar la pantalla, donde el estado está a la vista.
   * La alternativa —doce por siete entradas— sería una tabla que nadie mantiene.
   */
  PORTAL_TRANSITION_NOT_ALLOWED:
    'Esta acción no está disponible para el estado actual del expediente. Actualiza la página para ver en qué estado está.',

  /*
   * El enlace existe pero ya no abre nada: el expediente se aprobó, se rechazó, se canceló, venció
   * o el cliente ya entregó y está en revisión.
   *
   * El texto dice **por qué no** y no sólo «no se puede», porque el error llega en el peor momento
   * posible: el asesor está por pegar el enlace en un chat. Enterarse acá es barato; enterarse
   * cuando el cliente contesta «no me abre» cuesta una vuelta entera.
   */
  PORTAL_LINK_NOT_SHAREABLE:
    'El enlace de este expediente ya no abre el formulario. Revisa su estado en la pantalla: si el cliente todavía tiene que completarlo, primero solicítale correcciones.',

  /*
   * A diferencia del de arriba, este SÍ puede decir qué hacer, porque la salida es una sola: el
   * expediente no está sobre la mesa del revisor, y la forma de ponerlo ahí es traerlo a revisión.
   *
   * El texto nombra la acción con las palabras del botón —«Traer a revisión»— y no con el nombre
   * técnico de la transición: quien lee esto está mirando la pantalla donde ese botón está.
   */
  PORTAL_REQUEST_NOT_UNDER_REVIEW:
    'Este expediente todavía no está en revisión, así que no se pueden anotar campos. Usa "Traer a revisión" para tomarlo.',

  /*
   * Lo lanza el alta del portal cuando el `cli_` no resuelve. Distinto de `ERROR_CLIENT_NOT_FOUND`,
   * que es de v1 y ya está más arriba: se traducen los dos porque los dos pueden llegar mientras
   * la migración conviva, y unificarlos ahora obligaría a tocar el carril de clientes.
   */
  CLIENT_NOT_FOUND:
    'No se encontró el cliente. Es posible que se haya eliminado o que el enlace sea de otro entorno.',

  CREDIT_NOT_FOUND:
    'No se encontró el crédito. Es posible que se haya eliminado o que el enlace sea de otro entorno.',
  CREDIT_TEMPLATE_NOT_FOUND: 'No se encontró la plantilla del proceso de crédito.',
  CREDIT_TEMPLATE_NOT_PUBLISHED: 'La plantilla todavía no tiene una versión publicada.',
  CREDIT_TEMPLATE_DRAFT_NOT_FOUND: 'Guarda un borrador antes de publicar la plantilla.',
  CREDIT_TEMPLATE_INVALID: 'La plantilla tiene conexiones o configuraciones que debes revisar.',
  CREDIT_TEMPLATE_CHANGED:
    'La plantilla cambió mientras la editabas. Recarga la vista e inténtalo de nuevo.',
  CREDIT_TEMPLATE_SYSTEM_REQUIRED:
    'La plantilla operativa del proceso de Créditos no se puede eliminar.',
  CREDIT_TEMPLATE_IN_USE: 'No puedes eliminar una plantilla usada por expedientes en curso.',
  CREDIT_TEMPLATE_NOTICE_NOT_FOUND:
    'El aviso ya no existe en la plantilla. Recarga la vista e inténtalo de nuevo.',
  CREDIT_TEMPLATE_USER_EMAIL_NOT_FOUND:
    'Tu cuenta no tiene un correo activo para recibir el correo de prueba.',
  CREDIT_ALREADY_APPROVED: 'Este crédito ya fue aprobado y no admite más cambios.',
  CREDIT_CANCELLED: 'Este crédito está cancelado y no admite más cambios.',
  CREDIT_STAGE_NOT_FOUND: 'La etapa solicitada ya no existe en este expediente.',
  CREDIT_ITEM_NOT_FOUND: 'El punto solicitado ya no existe en esta etapa.',
  CREDIT_FIELD_NOT_FOUND: 'El campo solicitado ya no existe en este punto.',
  CREDIT_STAGE_SKIPPED: 'Esta etapa fue salteada por la modalidad del expediente.',
  CREDIT_ITEM_NOT_APPLICABLE: 'Este punto no aplica a la modalidad del expediente.',
  CREDIT_STAGE_NOT_ACTIVE: 'Sólo puedes avanzar la etapa que está en curso.',
  CREDIT_FIELD_VALUE_MISMATCH: 'La respuesta no tiene el formato que pide este campo.',
  CREDIT_FIELD_READ_ONLY: 'Este campo lo calcula el sistema y no se puede editar.',
  CREDIT_STAGE_BLOCKED: 'Completa los campos obligatorios antes de avanzar.',
  CREDIT_PROCESS_INCOMPLETE:
    'Para cerrar el crédito no puede quedar nada pendiente. Revisa lo que falta y vuelve a intentarlo.',
  CREDIT_STAGE_MOVED:
    'El expediente avanzó en otra sesión. La pantalla se actualizará con la etapa vigente.',
  CREDIT_FINANCING_TYPE_REQUIRED: 'Elige Crédito o Contado antes de avanzar.',
  CREDIT_ROUTE_DECISION_LOCKED:
    'Esta decisión quedó fija al cerrar su etapa. Para cambiarla hace falta reabrir el proceso.',
  CREDIT_TEMPLATE_VERSION_NOT_FOUND:
    'No se encontró la versión del flujo con la que nació este expediente.',
  CREDIT_BRANCH_TARGET_NOT_FOUND: 'La ruta configurada para esta modalidad ya no existe.',
  // Ya no llega al marcar un punto: el permiso pasó a gatear la PUBLICACIÓN de una plantilla que le
  // escribe al comprador. El texto nombra el acto que se rechazó, no una capacidad abstracta.
  CREDIT_NOTIFY_CLIENT_FORBIDDEN:
    'No tienes permiso para publicar una plantilla que le escribe al cliente. Quita esos destinatarios o pide el permiso «Avisar al cliente».',
  // Los tres del ALTA manual. ☠️ Se escaparon del guardarraíl `v2-mechanical-codes-translated`
  // —que sí exige texto para todo `*_NOT_FOUND`— porque el caso de uso los lanza como
  // `errorCode: ERRORS_CREDITS.X` y el barrido sólo ve literales. Es el límite que ese archivo
  // declara, y esta es la primera vez que muerde.
  CREDIT_NEGOTIATION_NOT_FOUND: 'La negociación de este trámite ya no existe.',
  CREDIT_NEGOTIATION_NOT_CLOSED:
    'El trámite de crédito sólo se abre sobre una negociación cerrada. Cierra la negociación primero.',
  CREDIT_ALREADY_EXISTS:
    'Esta negociación ya tiene un expediente de crédito abierto. Búscalo en el listado.',
  // La demo de la revisión de tiendas (ADR 0041). Sólo los ve quien opera la demo —el seed o un
  // visor autorizado—, pero sin texto acá caerían al `detail` en inglés del servidor.
  DEMO_VIEWER_REQUIRED: 'Sólo las personas autorizadas para la demostración pueden hacer esto.',
  ERROR_PROPERTY_NOT_DEMO:
    'Este inmueble no es de la demostración. Las negociaciones de demostración sólo se crean sobre inmuebles demo.',
  ERROR_CLIENT_NOT_REVIEWER:
    'Este cliente no es el de la cuenta de revisión de las tiendas. Elige ese cliente.',
  ERROR_ACCOUNT_NOT_REVIEWER:
    'Esta cuenta no es la de revisión de las tiendas, así que no se puede dejar como nueva.',
  ERROR_STORE_REVIEW_NOT_CONFIGURED:
    'La cuenta de revisión de las tiendas no está configurada en el servidor.',
  ERROR_END_STATE_NOT_RESOLVED:
    'No se encontró el estado final del flujo de negociación. Revisa la configuración de estados.',
  ERROR_DEFAULT_AGENCY_NOT_RESOLVED:
    'No se pudo determinar la agencia por defecto de la empresa: tiene que haber exactamente una.'
}
